import homeIcon from '@/shared/assets/icons/HomeIcon.svg';
import dashboardIcon from '@/shared/assets/icons/DashboardIcon.svg';
import vectorIcon from '@/shared/assets/icons/VectorIcon.svg';
import inboxIcon from '@/shared/assets/icons/Inbox.svg';
import fileTexMultiple from '@/shared/assets/icons/FileTextMultiple.svg';
import folderIcon from '@/shared/assets/icons/FolderIcon.svg';
import tableIcon from '@/shared/assets/icons/TableIcon.svg';
import historyIcon from '@/shared/assets/icons/HistoryIcon.svg';
import TrainingIcon from '@/shared/assets/icons/TrainingIcon.svg';
import boxArchiveIcon from '@/shared/assets/icons/BoxArchiveIcon.svg';
import notificationsIcon from '@/shared/assets/icons/NotificationIcon.svg';
import { MenuItem } from '@/shared/lib';

export const MENU_ITEMS: MenuItem[] = [
  { icon: homeIcon, alt: 'Inicio', text: 'Início', routeName: 'Home', route: '/' },
  {
    icon: dashboardIcon,
    alt: 'Dashboard',
    text: 'Dashboard',
    routeName: 'Dashboard',
    route: '/dashboard',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
  {
    icon: vectorIcon,
    alt: 'Verificado',
    text: 'Homologação',
    routeName: 'Homologação',
    route: '/homologacao',
    permissions: [
      { action: 'manageApproval', subject: 'Homologation' },
      { action: 'manageVerification', subject: 'Homologation' },
      { action: 'send', subject: 'Document' },
      { action: 'manage', subject: 'RecordManagement' },
    ],
    matchMode: 'any' as const,
  },
  {
    icon: tableIcon,
    alt: 'Tabela',
    text: 'Gestão de Registros',
    routeName: 'GestaoRegistros',
    route: '/gestao-registros/lista-registros',
    permissions: [{ action: 'manage', subject: 'RecordManagement' }],
  },
  {
    icon: fileTexMultiple,
    alt: 'Documento',
    text: 'Gestão de Documentos',
    routeName: 'GestaoDocumentos',
    route: '/gestao-documentos',
    permissions: [{ action: 'manage', subject: 'DocumentManagement' }],
  },
  {
    icon: folderIcon,
    alt: 'Pasta',
    text: 'Diretórios',
    routeName: 'Diretorios',
    route: '/diretorios',
    permissions: [{ action: 'read', subject: 'Directory' }],
  },
  {
    icon: inboxIcon,
    alt: 'Caixa de correio',
    text: 'Notificações',
    routeName: 'Notificacao',
    route: '/notificacao/minhas-notificacoes',
  },
  {
    icon: historyIcon,
    alt: 'Histórico',
    text: 'Histórico de Vigências',
    routeName: 'HistoricoVigencias',
    route: '/historico-vigencias',
    permissions: [{ action: 'manage', subject: 'ValidityHistory' }],
  },
  {
    icon: TrainingIcon,
    alt: 'Treinamento',
    text: 'Treinamentos',
    routeName: 'Treinamentos',
    route: '/treinamentos',
  },
  {
    icon: boxArchiveIcon,
    alt: 'Caixa',
    text: 'Logs de Operações',
    routeName: 'LogsOperacoes',
    route: '/logs-operacoes',
    permissions: [{ action: 'manage', subject: 'OperationLog' }],
  },
  {
    icon: notificationsIcon,
    alt: 'Notificação',
    text: 'Histórico de Avisos',
    routeName: 'HistoricoAvisos',
    route: '/historico-avisos/meu-historico',
  },
];
